import { Card, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useBarChart } from "../hooks/useBarChart";
import { calculateNpsScore } from "../utils/calculateNpsScore";
import { Loader } from "./Loader";
import { AppBarChart } from "./charts/BarChart";
import { detractors, promoters } from "../constants/constants";

const DseNpsBarChart = ({ data }) => {
  const { graphData, loading, setGraphData, setLoading, setYAxis, yAxis } =
    useBarChart();

  function calculateDseNps(responses) {
    const dseNps = {};

    for (const response of responses) {
      const DSE = response.DSE;
      if (response.feedback) {
        if (!dseNps[DSE]) {
          dseNps[DSE] = {
            promoters: 0,
            detractors: 0,
            total: 0,
          };
        }

        if (
          promoters.includes(response.feedback)
        ) {
          dseNps[DSE].promoters++;
        } else if (
          detractors.includes(response.feedback)
        ) {
          dseNps[DSE].detractors++;
        }
        dseNps[DSE].total++;
      }
    }
    let dseArr = [];

    for (const DSE in dseNps) {
      const { promoters, detractors, total } = dseNps[DSE];
      let NPS = calculateNpsScore(promoters, detractors, total);
      NPS = NPS.toFixed(0);
      dseArr.push({ "Sales Executive": DSE, NPS });
    }

    const bottom5 = dseArr
      .sort((a, b) => parseInt(a.NPS) - parseInt(b.NPS))
      .slice(0, 5);
    const values = dseArr.map((item) => Number(item.NPS));
    setYAxis({ min: Math.min(...values), max: Math.max(...values) });
    return bottom5;
  }

  useEffect(() => {
    if (data) {
      setGraphData(calculateDseNps(data));
      setLoading(false);
    }
  }, [data]);

  return (
    <Card
      variant="outlined"
      sx={{
        boxShadow: 3,
        width: "100%",
        height: "320px",
        p: "15px",
        background: "#1d2637",
        color: "white",
        borderRadius: "12px",
        fontFamily: "Montserrat, serif !important",
      }}
    >
      <Typography
        variant="overline"
        gutterBottom
        sx={{ fontFamily: "Montserrat, serif !important" }}
      >
        Bottom 5 : Sales Executive-wise NPS
      </Typography>

      {loading ? (
        <Loader />
      ) : (
        <AppBarChart
          data={graphData}
          xAxisKey={"Sales Executive"}
          xLabel={"Sales Executive"}
          yLabel={"NPS Score"}
          dataKey={"NPS"}
          yMax={yAxis.max}
          yMin={yAxis.min}
          fill="#00A6FB"
        />
      )}
    </Card>
  );
};

export default DseNpsBarChart;
